import React, { useId } from "react";
import { strings } from "../../resources/strings";
import { langAttribute } from "../../utils/questionUtils";
import { CategoryOption } from "./resourceUtils";

type CategoryFilterProps = {
  options: CategoryOption[];
  /** `null` means all categories. */
  value: string | null;
  onChange: (categoryId: string | null) => void;
};

const ALL_VALUE = "";

/** A native select: keyboard, screen reader and mobile pickers work as-is. */
const CategoryFilter: React.FC<CategoryFilterProps> = ({
  options,
  value,
  onChange,
}) => {
  const selectId = useId();
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={selectId} className="text-sm font-semibold text-gray-900">
        {strings.resources.categoryLabel}
      </label>
      <select
        id={selectId}
        className="select select-bordered w-full max-w-xs"
        value={value ?? ALL_VALUE}
        onChange={(event) => onChange(event.target.value || null)}
      >
        <option value={ALL_VALUE}>{strings.resources.allCategories}</option>
        {options.map((option) => (
          <option
            key={option.id}
            value={option.id}
            lang={langAttribute(option.locale)}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategoryFilter;
